<itb-text [className]="'text-default'" [text]="'Notification'"></itb-text>
<div *ngFor="let items of notifications">
  <itb-text [className]="'text-small'" [text]="items.activity"></itb-text>
  <itb-text [className]="'text-small'" [text]="items.username"></itb-text>
  <itb-text [className]="'text-x-small'" [text]="items.UpdatingTime"></itb-text>
  <itb-text [className]="'text-default'" [text]="items.exportType"></itb-text>
</div>
